import { render, staticRenderFns } from "./LoadingTemplatesList.vue?vue&type=template&id=2f66a77e&lang=pug&"
import script from "./LoadingTemplatesList.vue?vue&type=script&lang=js&"
export * from "./LoadingTemplatesList.vue?vue&type=script&lang=js&"
import style0 from "./LoadingTemplatesList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports